/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './uploadcsvpicker.tpl.html';

angular
  .module('shared.uploadCSVPicker', ['ngFileUpload'])
  /**
   * Controller for the shared/uploadcsvpicker/uploadcsvpicker.tpl.html template.
   */
  .controller(
    'UploadCsvPickerCtrl',
    function ($scope, $injector, $rootScope, $filter, $timeout, batchUtils, ALERT_EVENTS) {
      $scope.fileName = '';

      // Lookup the store provider for the picker.
      var PickerStore = $injector.get($scope.storeName);

      // Create store for the date pickers
      $scope.pickerStore = new PickerStore();

      /**
       * Utility to emit error if invalid date is selected.
       *
       * @param {object} pickerStore - the PickerStore object.
       */
      $scope.invalidDate = function (pickerStore) {
        var removeInvalidOutline = function () {
          pickerStore.invalidSelectedDate = false;
        };

        pickerStore.invalidSelectedDate = true;
        $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('INVALID_DATE'));
        $timeout(removeInvalidOutline, 10000);
      };

      /**
       * Utility to upload a csv file.
       * @param {file} file - the file uploaded by user.
       * @param {file} errFiles - the file if errors occur during upload
       */
      $scope.upload = function (file, errFiles) {
        if (file && errFiles.length === 0) {
          $scope.uploadedCsv = true;
          $scope.uploadedFile = file;
          $scope.fileName = $scope.uploadedFile.name;
        }
      };

      /**
       * Utility to clear out the uploaded $scope.uploadedFile.
       */
      $scope.clearFile = function () {
        $scope.uploadedCsv = false;
        $scope.uploadedFile = undefined;
        $scope.fileName = '';
      };

      // If we have values in $scope.batchIdToVerify we want to get that batch.
      // Otherwise default to latest batch
      if ($scope.batchIdToVerify) {
        $scope.pickerStore.getBatch($scope.batchIdToVerify);
      } else {
        batchUtils.getBatches(1, true).then(
          function (batches) {
            if (batches.rows.length > 0) {
              $scope.pickerStore.batchObject = batches.rows[0];
            }
          },
          function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('ERROR_OCCURRED'));
          }
        );
      }

      if ($scope.uploadedFile && $scope.uploadedFile.name) {
        $scope.fileName = $scope.uploadedFile.name;
      }

      $scope.$watch(
        function () {
          return $scope.pickerStore.batchObject.batchId;
        },
        function (newVal) {
          if (newVal) {
            // Reset the invalidSelectedDate flag every time date is changed
            if ($scope.pickerStore.lastValidBatch && newVal !== $scope.pickerStore.lastValidBatch.batchId) {
              $scope.pickerStore.invalidSelectedDate = false;
            }

            $scope.batchIdToVerify = newVal;
          }
        }
      );
    }
  )
  /**
   * The directive for the upload csv picker view. The storeName attribute should be
   * the name of the Store factory implementation to provide data to the picker.
   *
   * storeName - this should be a BasicBatchPickerStore.
   * batchIdToVerify - this is the batch to verify the uploaded file against.
   * uploadedCsv - Boolean flag if a csv has been uploaded or not.
   * uploadedFile - the uploaded file.
   */
  .directive('uploadcsvpicker', function () {
    return {
      templateUrl: 'shared/uploadcsvpicker/uploadcsvpicker.tpl.html',
      scope: {
        storeName: '@storeName',
        batchIdToVerify: '=',
        invalidDate: '&',
        uploadedCsv: '=',
        uploadedFile: '=',
        msg: '@'
      },
      controller: 'UploadCsvPickerCtrl'
    };
  });
